__turbopack_context__.v({
  "appearAnimation": "TitleVideoAutoplaySection-module__1BGm6W__appearAnimation",
  "replayBtn": "TitleVideoAutoplaySection-module__1BGm6W__replayBtn",
  "root": "TitleVideoAutoplaySection-module__1BGm6W__root",
  "videoContainer": "TitleVideoAutoplaySection-module__1BGm6W__videoContainer",
});
